import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
import { Main } from 'components/Main';
const ManageAppsRaw = React.lazy(() => import(/* webpackChunkName: "ManageAppsPage" */ './ManageApps'));
export const ManageApps = () => (React.createElement(Page, { title: "Manage Appearances" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(ManageAppsRaw, null)))));
